//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import { createSelector } from '@reduxjs/toolkit';

import { ICuralateStore } from '@models/AppState';

const getMediaUploadQueue = (state: ICuralateStore) => state.mediaUploadQueue;

export const getQueuedItemIds = createSelector(
  getMediaUploadQueue,
  (queue) => queue.queuedItemIds,
);

export const getUploadQueueStatus = createSelector(
  getMediaUploadQueue,
  (queue) => queue.status,
);
